<template>
    <div>
        <div class="login-title font-M1">
            <div style="margin: auto; width: 100px;">
                <img src="/Content/images/logo_mis.png" style="width: 100px;" />
            </div>
            <div class="media-body">
                <div class="text-center" style="padding: 8px 0;">កម្មវិធីគ្រប់គ្រងទិន្នន័យ</div>
                <div class="text-center" style="padding: 5px 0;">ការផ្តល់សេវារដ្ឋ​បាលនៅរដ្ឋបាលថ្នាក់ក្រោមជាតិ</div>
            </div>
        </div>
        <div class="login-content">
            <div class="form-group">
                <label class="control-label font-KB">ឈ្មោះគណនី</label>
                <div>
                    <input type="text" class="form-control" v-model="login.UserName" v-on:keyup.enter="$refs.password.focus()" />
                </div>
            </div>
            <div class="form-group">
                <label class="control-label font-KB">ពាក្យសំងាត់</label>
                <div>
                    <input type="password" class="form-control" ref="password" v-model="login.Password" v-on:keyup.enter="onLogin" />
                </div>
            </div>
            <br />
            <div class="form-group">
                <input type="button" value="ចូលក្នុងប្រព័ន្ធ" class="btn btn-info btn-block font-M1" v-on:click="onLogin" />
            </div>
        </div>
    </div>
</template>
<script>
    import qs from 'qs';
    import axios from 'axios';
    import Swal from 'sweetalert2';
    export default {
        data() {
            return {
                login: {},
                required2fa: false
            }
        },
        methods: {
            onLogin () {
                var loading = this.loading();
                this.login.__RequestVerificationToken = $('[name="__RequestVerificationToken"]').val();
                this.login.Required2FA = this.required2fa;
                axios.post(path('Account/Login'), qs.stringify(this.login)).then(res => {
                    loading.hide();
                    const data = res.data
                    if (data.IsError) {
                        Swal.fire('Warning Message', data.ErrorMessage, 'error');
                    } else {
                        if (this.required2fa) {
                            const userData = {
                                ...this.login,
                                ...JSON.parse(data.Json.User)
                            };
                            this.$emit("success", userData);
                        }
                        else window.location = data.Json.Link;
                    }
                });
            },
            loading: function () {
                return this.$loading.show({
                    color: '#0856ab'
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Components/Auth/Verify.vue